var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportWhite = function SvgSupportWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.255.303A7 7 0 0 0 .258 7.3a7 7 0 0 0 6.997 6.997A7 7 0 0 0 14.252 7.3 7 7 0 0 0 7.255.303Zm5.22 4.982-1.945.805a3.486 3.486 0 0 0-2.064-2.057l.804-1.945a5.571 5.571 0 0 1 3.205 3.197ZM7.255 9.4c-1.161 0-2.099-.937-2.099-2.099 0-1.161.938-2.099 2.1-2.099 1.16 0 2.098.938 2.098 2.1 0 1.16-.937 2.098-2.099 2.098ZM5.247 2.081l.819 1.945A3.499 3.499 0 0 0 3.98 6.104l-1.945-.812a5.587 5.587 0 0 1 3.211-3.211ZM2.036 9.309l1.945-.805a3.476 3.476 0 0 0 2.078 2.071L5.24 12.52A5.594 5.594 0 0 1 2.036 9.31ZM9.27 12.52l-.804-1.945a3.484 3.484 0 0 0 2.064-2.078l1.945.819A5.602 5.602 0 0 1 9.27 12.52Z",
    fill: "#FFF"
  })));
};
export default SvgSupportWhite;